@import 'src/client/view/style/constants.scss';

.container {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
